import useApi from "./useApiRequest";
import { useMutation } from "react-query";

export const GetAllStandarsList = ()  => {
    const api = useApi();

    const mutate = async () => {
        const data  = await api.get(`/standars/list`);
        return data.data;
    };

    const mutation = useMutation(mutate);

    return {
        getAllStandarsListMutation: mutation.mutate,
    };
}